/** Ai 角色 CMS 整数大类（列表 / 导出 / 打标）。 */
export const AI_ASSISTANT_LIST_RESOURCE_TYPE = 15

/** 分类树 classifyTag 接口 type 参数（与列表 resourceType 不同）。 */
export const AI_ASSISTANT_CLASSIFY_TYPE = 17

/** 保存契约 wallpaperType 固定值。 */
export const AI_ASSISTANT_ASSET_TYPE = 'ai_assistant'

/** FormShell 治理区块 profile，与通用资源 link_default 一致。 */
export const AI_ASSISTANT_GOVERNANCE_PROFILE = 'link_default'

/** welcome / starters 运营端最多条数；保存仍写 json_config 字符串数组。 */
export const AI_ASSISTANT_ROLE_LIST_MAX = 3
